import { BllKategoriler } from './../../../providers/bll/bll-kategoriler';
import { EtiketlistesiPage } from './../etiketlistesi/etiketlistesi';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { Blletiket } from './../../../providers/bll/bll-etiket';
import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';




@Component({
  selector: 'page-etiketbas',
  templateUrl: 'etiketbas.html',
})
export class EtiketbasPage {
  @ViewChild('sideNavUrunAra') sideNav;
  aranan = "";
  take: number = 50;
  UrunListesi = [];
  etiketListesi: any = { ETIKET_DETAYLARI: [] };
  aktarilanliste = [];
  KategoriListesi = [];
  secilenkategoriID: number = -1;

  constructor(public navCtrl: NavController, public navParams: NavParams, public bllOrtak: BllOrtak,
    public toast: ToastController,
    public modalCtrl: ModalController,
    public ortak: Ortak,
    public barcodeScanner: BarcodeScannerProvider) {
  }

  ionViewDidLoad() {

    this.UrunAra();
    this.KategoriGetir();
  }
  KategoriGetir() {
    var kategoriler = new BllKategoriler();
    kategoriler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(KategoriAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + "" + "%' or KategoriAdi='" + "" + "')" + " order by Sort").then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc;
      if (this.KategoriListesi == null || this.KategoriListesi.length == 0) {
        var formData = new FormData();
        formData.append("aranan", "");
        this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
          var sonuc = <any>a;
          this.KategoriListesi = sonuc.SonucObject;
        })
      }
    });

  }
  UrunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("katid", this.secilenkategoriID.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.UrunListesi = sonuc.SonucObject;
      this.closeNav();
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }

  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.UrunAra();
    })
  }
  barkodara() {
    this.barcodeScanner.barkodOku().then(barcodeData => {

    }).catch(err => {
      console.log('Error', err);
    });
  }

  urunItemClick(urun) {
    var blletiket = new Blletiket();
    blletiket.rafetiketkle(urun.StokKartiID, urun.ID, urun.StokAdi,urun.Barcode1,urun.Barcode2,urun.Price1,urun.Price2,
      urun.Price3,urun.Price4,urun.FiyatDegisimTarihi,urun.UlkeAdi,urun.BirimAdi,1)
    this.presentToast(urun.StokAdi + "     " + "   " + "Listeye Eklendi");
  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
        position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  ozet() {
    let modal = this.modalCtrl.create(EtiketlistesiPage,"",{cssClass:"genisekran"});
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {

    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";

  }



}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/etiketbas/etiketbas.ts